export default "__VITE_ASSET__DPShWOOJ__"